import './index.styl';
// import ScrollMagic from 'scrollmagic';
import {
  TweenMax,
  Power2,
  TimelineMax,
  TimelineLite,
  TweenLite
} from 'gsap/TweenMax';
import Typed from 'typed.js';
import $ from 'jquery';

//-------------------------------typing effect
let options = {
  // strings: ["First ^1000 sentence.", "Second sentence."],
  strings: ['a Developer ^1000', 'a Designer ^1000', 'a Scientist ^1000'],
  typeSpeed: 90,
  loop: true
};
let typed = new Typed('#typed', options);

//-------------------------------scroll down smooth
$(document).on('click', 'a[href^="#"]', function(e) {
  e.preventDefault();
  $('html, body')
    .stop()
    .animate(
      {
        scrollTop: $($(this).attr('href')).offset().top
      },
      500,
      'swing'
    );
});
//-------------------------------timelineMax
const LogoContent = document.querySelector('.LogoContent');

const tl = new TimelineMax();
tl.fromTo(LogoContent, 2, { x: '300%' }, { x: '0%', ease: Power2.easeInOut });

const screen = document.querySelector('.screen');
const desinger = document.querySelector('.desinger');
const scienist = document.querySelector('.scienist');
const tl2 = new TimelineMax({ repeat: -1 });
tl2
  .fromTo(
    screen,
    1.5,
    { x: '100%' },
    { x: '0%', opacity: 1, ease: Power2.easeInOut }
  )
  .fromTo(
    screen,
    1.5,
    { x: '0%' },
    { x: '-100%', opacity: 0, ease: Power2.easeInOut }
  )
  .fromTo(
    desinger,
    1.5,
    { x: '100%' },
    { x: '0%', opacity: 1, ease: Power2.easeInOut }
  )
  .fromTo(
    desinger,
    1.5,
    { x: '0%' },
    { x: '-100%', opacity: 0, ease: Power2.easeInOut }
  )
  .fromTo(
    scienist,
    1.5,
    { x: '100%' },
    { x: '0%', opacity: 1, ease: Power2.easeInOut }
  )
  .fromTo(
    scienist,
    1.5,
    { x: '0%' },
    { x: '-100%', opacity: 0, ease: Power2.easeInOut }
  );

//-------------------------------nav
const navSlide = () => {
  const hamburger = document.querySelector('.hamburger');
  const navLink = document.querySelector('ul.nav-link');
  const navLinks = document.querySelectorAll('ul.nav-link li');
  hamburger.addEventListener('click', () => {
    navLink.classList.toggle('nav-active');
    navLinks.forEach((link, index) => {
      if (link.style.animation) {
        link.style.animation = '';
      } else {
        link.style.animation = `navOpt 0.5s ease forwards ${index / 7 + 0.5}s`;
      }
    });
    hamburger.classList.toggle('toggle');
  });
};
navSlide();

//-------------------------------navScrolling
$(window).on('scroll', function() {
  if ($(window).scrollTop()) {
    $('nav').addClass('show');
  } else {
    $('nav').removeClass('show');
  }
});

//-------------------------------academic experience

$('#b2017').click(function() {
  $('#a2017').css('z-index', '3');
  $('#a2016').css('z-index', '1');
  $('#a2018').css('z-index', '1');
});
$('#b2016').click(function() {
  $('#a2016').css('z-index', '3');
  $('#a2017').css('z-index', '2');
  $('#a2018').css('z-index', '1');
});
$('#b2018').click(function() {
  $('#a2018').css('z-index', '3');
  $('#a2016').css('z-index', '1');
  $('#a2017').css('z-index', '1');
});

$('#a2017').click(function() {
  $('#a2017').css('z-index', '3');
  $('#a2016').css('z-index', '1');
  $('#a2018').css('z-index', '1');
});
$('#a2016').click(function() {
  $('#a2016').css('z-index', '3');
  $('#a2017').css('z-index', '2');
  $('#a2018').css('z-index', '1');
});
$('#a2018').click(function() {
  $('#a2018').css('z-index', '3');
  $('#a2016').css('z-index', '1');
  $('#a2017').css('z-index', '1');
});
